import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const BLOK_TYPES = [
  { value: 'goed_fout_nvt', label: 'Goed / Fout / NVT', icon: '✓' },
  { value: 'goed_fout', label: 'Goed / Fout', icon: '✓' },
  { value: 'tekst', label: 'Tekst', icon: '📝' },
  { value: 'nummer', label: 'Nummer', icon: '🔢' },
  { value: 'nummer_eenheid', label: 'Nummer + eenheid', icon: '📏' },
  { value: 'foto', label: 'Foto', icon: '📷' },
  { value: 'handtekening', label: 'Handtekening', icon: '✍️' },
  { value: 'dropdown', label: 'Dropdown', icon: '▼' },
  { value: 'datum', label: 'Datum', icon: '📅' },
  { value: 'checkbox', label: 'Checkbox', icon: '☑' },
];

const input = { width: '100%', padding: '9px 11px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' };
const btnP = { padding: '10px 18px', borderRadius: 8, border: 'none', background: '#2563eb', color: 'white', fontWeight: 600, fontSize: 14, cursor: 'pointer' };

export default function ChecklistBlokken() {
  const navigate = useNavigate();
  const [toonImport, setToonImport] = useState(false);
  const [blokken, setBlokken] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editId, setEditId] = useState(null); // null = geen editor, 'new' = nieuw, getal = bewerken
  const [naam, setNaam] = useState('');
  const [omschrijving, setOmschrijving] = useState('');
  const [items, setItems] = useState([]);
  const [bezig, setBezig] = useState(false);

  const laad = async () => {
    setLoading(true);
    try {
      const r = await api.get('/checklists/blokken');
      setBlokken(r.data.blokken || []);
    } catch (e) { /* stil */ }
    setLoading(false);
  };
  useEffect(() => { laad(); }, []);

  const nieuw = () => { setEditId('new'); setNaam(''); setOmschrijving(''); setItems([{ label: '', type: 'goed_fout_nvt', opties: [] }]); };

  const bewerk = async (id) => {
    try {
      const r = await api.get('/checklists/blokken/' + id);
      setEditId(id);
      setNaam(r.data.blok.naam || '');
      setOmschrijving(r.data.blok.omschrijving || '');
      setItems((r.data.items || []).map(it => ({
        label: it.label, type: it.type, eenheid: it.eenheid || '',
        opties: it.dropdown_opties ? it.dropdown_opties.split('|') : [], kolom: it.kolom || 'links'
      })));
    } catch (e) { alert('Kon blok niet laden'); }
  };

  const setItem = (idx, patch) => setItems(items.map((it, i) => i === idx ? { ...it, ...patch } : it));
  const voegItem = () => setItems([...items, { label: '', type: 'goed_fout_nvt', opties: [] }]);
  const verwijderItem = (idx) => setItems(items.filter((_, i) => i !== idx));
  const verplaats = (idx, richting) => {
    const j = idx + richting;
    if (j < 0 || j >= items.length) return;
    const kopie = [...items];
    [kopie[idx], kopie[j]] = [kopie[j], kopie[idx]];
    setItems(kopie);
  };

  const opslaan = async () => {
    if (!naam.trim()) { alert('Geef het blok een naam'); return; }
    const geldig = items.filter(it => (it.label || '').trim());
    if (geldig.length === 0) { alert('Voeg minstens 1 controlepunt toe'); return; }
    setBezig(true);
    try {
      const payload = {
        naam: naam.trim(), omschrijving: omschrijving.trim(),
        items: geldig.map(it => ({
          label: it.label.trim(), type: it.type, eenheid: it.eenheid || null,
          dropdown_opties: it.type === 'dropdown' ? (it.opties || []).join('|') : null, kolom: it.kolom || 'links'
        }))
      };
      if (editId === 'new') await api.post('/checklists/blokken', payload);
      else await api.put('/checklists/blokken/' + editId, payload);
      setEditId(null);
      laad();
    } catch (e) { alert('Opslaan mislukt: ' + (e.response?.data?.message || e.message)); }
    setBezig(false);
  };

  const verwijderBlok = async (id, blokNaam) => {
    if (!window.confirm('Blok "' + blokNaam + '" verwijderen?')) return;
    try { await api.delete('/checklists/blokken/' + id); laad(); }
    catch (e) { alert('Verwijderen mislukt'); }
  };

  // ---- Editor ----
  if (editId !== null) {
    return (
      <div style={{ padding: 24, maxWidth: 720, margin: '0 auto' }}>
        <button onClick={() => setEditId(null)} style={{ background: '#f1f5f9', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', marginBottom: 16 }}>&larr; Terug naar blokken</button>
        <h1 style={{ fontSize: 24, margin: '0 0 4px' }}>{editId === 'new' ? '🧱 Nieuw blok' : '🧱 Blok bewerken'}</h1>
        <p style={{ color: '#6b7280', marginTop: 0, fontSize: 14 }}>Een blok is een groepje controlepunten dat je later in een template kunt kiezen.</p>

        <div style={{ background: 'white', borderRadius: 12, padding: 18, border: '1px solid #e5e7eb', marginBottom: 16 }}>
          <label style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>Naam *</label>
          <input value={naam} onChange={e => setNaam(e.target.value)} placeholder="bijv. HFP" style={{ ...input, marginTop: 4, marginBottom: 12 }} />
          <label style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>Omschrijving (optioneel)</label>
          <input value={omschrijving} onChange={e => setOmschrijving(e.target.value)} placeholder="waar dit blok voor is" style={{ ...input, marginTop: 4 }} />
        </div>

        <div style={{ background: 'white', borderRadius: 12, padding: 18, border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 12 }}>Controlepunten ({items.length})</div>
          {items.map((it, idx) => (
            <div key={idx} style={{ border: '1px solid #e5e7eb', borderRadius: 10, padding: 12, marginBottom: 10, background: '#f9fafb' }}>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8 }}>
                <span style={{ fontSize: 13, color: '#94a3b8', fontWeight: 700, minWidth: 22 }}>{idx + 1}.</span>
                <input value={it.label} onChange={e => setItem(idx, { label: e.target.value })} placeholder="Controlepunt (bijv. spanning meten)" style={{ ...input, flex: 1 }} />
                <button onClick={() => verplaats(idx, -1)} disabled={idx === 0} style={{ border: '1px solid #d1d5db', background: 'white', borderRadius: 6, padding: '6px 8px', cursor: 'pointer', opacity: idx === 0 ? 0.4 : 1 }}>&uarr;</button>
                <button onClick={() => verplaats(idx, 1)} disabled={idx === items.length - 1} style={{ border: '1px solid #d1d5db', background: 'white', borderRadius: 6, padding: '6px 8px', cursor: 'pointer', opacity: idx === items.length - 1 ? 0.4 : 1 }}>&darr;</button>
                <button onClick={() => verwijderItem(idx)} style={{ border: '1px solid #fecaca', background: '#fef2f2', color: '#dc2626', borderRadius: 6, padding: '6px 8px', cursor: 'pointer' }}>&times;</button>
              </div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', paddingLeft: 30 }}>
                {BLOK_TYPES.map(t => (
                  <button key={t.value} onClick={() => setItem(idx, { type: t.value, opties: t.value === 'dropdown' && !(it.opties || []).length ? ['Optie 1', 'Optie 2'] : it.opties })}
                    style={{ padding: '5px 10px', borderRadius: 6, border: '2px solid', borderColor: it.type === t.value ? '#2563eb' : '#e2e8f0', background: it.type === t.value ? '#eff6ff' : 'white', color: it.type === t.value ? '#2563eb' : '#64748b', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                    {t.icon} {t.label}
                  </button>
                ))}
              </div>
              {it.type === 'dropdown' && (
                <div style={{ paddingLeft: 30, marginTop: 8 }}>
                  <input value={(it.opties || []).join('|')} onChange={e => setItem(idx, { opties: e.target.value.split('|') })} placeholder="Opties gescheiden met | (bijv. Ja|Nee|Nvt)" style={input} />
                </div>
              )}
              {it.type === 'nummer_eenheid' && (
                <div style={{ paddingLeft: 30, marginTop: 8 }}>
                  <input value={it.eenheid || ''} onChange={e => setItem(idx, { eenheid: e.target.value })} placeholder="Eenheid (bijv. V, A, bar)" style={{ ...input, maxWidth: 200 }} />
                </div>
              )}
            </div>
          ))}
          <button onClick={voegItem} style={{ width: '100%', padding: 10, border: '1px dashed #2563eb', background: '#eff6ff', color: '#2563eb', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>+ Controlepunt</button>
        </div>

        <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
          <button onClick={() => setEditId(null)} style={{ padding: '10px 18px', borderRadius: 8, border: '1px solid #d1d5db', background: 'white', cursor: 'pointer' }}>Annuleren</button>
          <button onClick={opslaan} disabled={bezig} style={{ ...btnP, opacity: bezig ? 0.6 : 1 }}>{bezig ? 'Opslaan…' : '💾 Blok opslaan'}</button>
        </div>
      </div>
    );
  }

  // ---- Lijst ----
  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
        <h1 style={{ margin: 0, fontSize: 28 }}>🧱 Checklist-blokken</h1>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => navigate('/templates')} style={{ background: '#f1f5f9', border: 'none', borderRadius: 8, padding: '10px 16px', cursor: 'pointer', fontWeight: 600 }}>&larr; Templates</button>
          <button onClick={() => setToonImport(true)} style={{ background: '#f1f5f9', border: '1px solid #cbd5e1', borderRadius: 8, padding: '10px 16px', cursor: 'pointer', fontWeight: 600 }}>📥 Uit template</button>
          <button onClick={nieuw} style={btnP}>+ Nieuw blok</button>
          {toonImport && <ImportUitTemplate onSluit={() => setToonImport(false)} onKlaar={() => { setToonImport(false); laad(); }} />}
        </div>
      </div>
      <p style={{ color: '#6b7280', marginTop: 0 }}>Herbruikbare groepjes controlepunten. Maak ze hier &eacute;&eacute;n keer, kies ze straks bij een nieuwe template.</p>

      {loading ? <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>Laden…</div>
        : blokken.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', background: 'white', borderRadius: 12, border: '1px solid #e5e7eb' }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>🧱</div>
            <div style={{ fontWeight: 600, color: '#374151' }}>Nog geen blokken</div>
            <div style={{ fontSize: 14, color: '#6b7280', marginTop: 4 }}>Maak je eerste blok (bijv. HFP) met de knop rechtsboven.</div>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 12 }}>
            {blokken.map(b => (
              <div key={b.id} style={{ background: 'white', borderRadius: 12, padding: 16, border: '1px solid #e5e7eb' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: 8 }}>
                  <div style={{ fontWeight: 700, fontSize: 16, color: '#111827' }}>🧱 {b.naam}</div>
                  <span style={{ background: '#eff6ff', color: '#2563eb', padding: '2px 8px', borderRadius: 8, fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}>{b.aantal_items} punten</span>
                </div>
                {b.omschrijving && <div style={{ fontSize: 13, color: '#6b7280', marginTop: 4 }}>{b.omschrijving}</div>}
                <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                  <button onClick={() => bewerk(b.id)} style={{ flex: 1, padding: 8, background: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>Bewerken</button>
                  <button onClick={() => verwijderBlok(b.id, b.naam)} style={{ padding: '8px 12px', background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 8, cursor: 'pointer' }}>🗑️</button>
                </div>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}


function ImportUitTemplate({ onSluit, onKlaar }) {
  const [templates, setTemplates] = useState([]);
  const [laden, setLaden] = useState(true);
  const [open, setOpen] = useState(null);
  const [gekozen, setGekozen] = useState({});
  const [bezig, setBezig] = useState(false);

  useEffect(() => {
    api.get('/checklists/blokken-bron')
      .then(r => setTemplates(r.data.templates || []))
      .catch(() => setTemplates([]))
      .finally(() => setLaden(false));
  }, []);

  const aantal = Object.values(gekozen).filter(Boolean).length;
  const toggle = id => setGekozen(g => ({ ...g, [id]: !g[id] }));
  const toggleAlles = t => {
    const allesAan = t.secties.every(s => gekozen[s.id]);
    setGekozen(g => { const n = { ...g }; t.secties.forEach(s => { n[s.id] = !allesAan; }); return n; });
  };
  const importeer = async () => {
    const ids = Object.keys(gekozen).filter(k => gekozen[k]).map(Number);
    if (!ids.length) return;
    setBezig(true);
    try {
      const r = await api.post('/checklists/blokken/van-secties', { sectie_ids: ids });
      alert(r.data.message);
      onKlaar();
    } catch (e) {
      alert(e.response?.data?.message || 'Importeren mislukt');
      setBezig(false);
    }
  };

  return (
    <div onClick={onSluit} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: 'white', color: '#0f172a', borderRadius: 12, width: '100%', maxWidth: 560, maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #e2e8f0' }}>
          <div style={{ fontWeight: 700, fontSize: 17 }}>📥 Blokken maken uit bestaande template</div>
          <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>Vink secties aan — elke sectie wordt een los blok met al z'n controlepunten.</div>
        </div>
        <div style={{ overflowY: 'auto', padding: '8px 20px', flex: 1 }}>
          {laden && <div style={{ padding: 20, color: '#64748b' }}>Laden…</div>}
          {!laden && !templates.length && <div style={{ padding: 20, color: '#64748b' }}>Geen templates met secties gevonden.</div>}
          {templates.map(t => {
            const aan = t.secties.filter(s => gekozen[s.id]).length;
            return (
              <div key={t.id} style={{ borderBottom: '1px solid #f1f5f9', padding: '10px 0' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <button onClick={() => setOpen(open === t.id ? null : t.id)} style={{ flex: 1, textAlign: 'left', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 14, color: '#0f172a', padding: 0 }}>
                    {open === t.id ? '▾' : '▸'} {t.naam} <span style={{ color: '#64748b', fontWeight: 400 }}>({t.secties.length} secties{aan ? ', ' + aan + ' gekozen' : ''})</span>
                  </button>
                  <button onClick={() => toggleAlles(t)} style={{ fontSize: 12, padding: '4px 10px', borderRadius: 6, border: '1px solid #cbd5e1', background: 'white', cursor: 'pointer' }}>
                    {t.secties.every(s => gekozen[s.id]) ? 'Geen' : 'Alles'}
                  </button>
                </div>
                {open === t.id && (
                  <div style={{ marginTop: 8, paddingLeft: 18 }}>
                    {t.secties.map(s => (
                      <label key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', cursor: 'pointer', fontSize: 14 }}>
                        <input type="checkbox" checked={!!gekozen[s.id]} onChange={() => toggle(s.id)} />
                        <span style={{ flex: 1 }}>{s.naam}</span>
                        <span style={{ fontSize: 12, color: '#64748b' }}>{s.aantal} punten</span>
                      </label>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div style={{ padding: '12px 20px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button onClick={onSluit} style={{ padding: '10px 18px', borderRadius: 8, border: '1px solid #d1d5db', background: 'white', cursor: 'pointer' }}>Annuleren</button>
          <button onClick={importeer} disabled={!aantal || bezig} style={{ padding: '10px 18px', borderRadius: 8, border: 'none', background: '#2563eb', color: 'white', fontWeight: 600, cursor: aantal && !bezig ? 'pointer' : 'default', opacity: aantal && !bezig ? 1 : 0.5 }}>
            {bezig ? 'Bezig…' : 'Maak ' + aantal + ' blok' + (aantal === 1 ? '' : 'ken')}
          </button>
        </div>
      </div>
    </div>
  );
}
